import React from 'react';
import { Container, Grid } from '@mui/material';
import IndexNumber from '../Components/Typography/IndexNumber';
import TechStack from '../Components/TechStack';
import Heading from '../Components/Typography/Heading';
import ContentWrapper from '../Components/ContentWrapper';
import { EarlyWrapper } from '../Components/animation/EarlyWrapper';
import { LateWrapper } from '../Components/animation/LateWrapper';
import { DelayedWrapper } from '../Components/animation/DelayedWrapper';

const Skills = () => {
  return (
    <ContentWrapper>
      <Container maxWidth='xxl'>
        <Grid container spacing={2}>
          {/* -----Number------- */}
          <Grid item xs={12} md={2} xl={2} xxl={2}>
            <EarlyWrapper>
              <IndexNumber number='02 /' />
            </EarlyWrapper>
          </Grid>
          {/* --------- Intro ----------- */}
          <Grid item xs={12} md={10} xl={10} xxl={10}>
            <LateWrapper>
              <Heading content='PROFICIENT TECHNOLOGIES' />
            </LateWrapper>
            {/* ------ Tech Stack -------- */}
            <DelayedWrapper>
              <TechStack />
            </DelayedWrapper>
          </Grid>
        </Grid>
      </Container>
    </ContentWrapper>
  );
};

export default Skills;
